/* unplugin-vue-components disabled */import { render } from "./IosHomeView.vue?vue&type=template&id=f21571e4&scoped=true"
import script from "./IosHomeView.vue?vue&type=script&lang=js"
export * from "./IosHomeView.vue?vue&type=script&lang=js"

import "./IosHomeView.vue?vue&type=style&index=0&id=f21571e4&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21571e4"]])

export default __exports__